export function getLabelClassName(type) {
    if (!type)
        return '';
    return 'badge rounded-pill bg-primary';
}
export function getAPIUrl() {
    const url = '/api/procurements/';
    if (window.location.host === 'oetc.org') {
        return `https://procurements.widgets.oetc.org${url}`;
    }
    return url;
}
export function getUrlPrefix() {
    return '/procurements/';
}
